import { useEffect, useRef } from "react";
import { useMessageBannerStore } from "../shared-zustand/MessageBannerStore";
import "./FunctionalMessageBanner.css";

export function FunctionalMessageBanner() {
  const { open, type, message, closeBanner } = useMessageBannerStore();
  const barRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (barRef.current) {
      barRef.current.removeAttribute("hidden");
    }

    const currentRef = barRef.current;

    const handleToggle = () => {
      closeBanner();
    };

    currentRef?.addEventListener("toggle", handleToggle);

    return () => {
      currentRef?.removeEventListener("toggle", handleToggle);
    };
  });

  if (!open) {
    return null;
  }

  return (
    <tractie-message-bar
      ref={barRef}
      className="functional-mb"
      dismissible
      situation={type}
      text={message}
    ></tractie-message-bar>
  );
}
